<template>
  <div class="c-left-side-bar">
    <c-modal-message v-if="!hide" :modal-type="modalType" :state.sync="state" :hide.sync="hide" />
    <div class="c-left-side-bar-container">
      <div class="logged-user" @click="showModal()">
        <div class="avatar-place">
          <img :src="altAvatar" alt="">
        </div>
        <p class="name">{{ user.fullName }}</p>
        <p>Проведено КЛН: {{ user.resultedCount }}</p>
      </div>
      <div class="page-icons">
        <div class="page-icon" :class="{'active': step===1, 'last-active': step===2, 'last-disabled' : step >= 3}">
          <img :src="step === 1 ? infoActive : infoDisabled" alt="">
        </div>
        <div class="page-icon" :class="{'active': step===2, 'last-active': step===3, 'last-disabled' : step===4}">
          <img :src="step === 2 ? usersActive : usersDisabled" alt="">
        </div>
        <div class="page-icon" :class="{'active': step===3, 'last-active': step===4}">
          <img :src="step === 3 ? categoriesActive : categoriesDisabled" alt="">
        </div>
        <div class="page-icon" :class="{'active': step===4}">
          <img :src="step === 4 ? quizActive : quizDisabled" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import altAvatar from 'assets/altAvatar/alt-avatar.png'
import infoDisabled from 'assets/klnIcons/kln-info-disactive.svg'
import infoActive from 'assets/klnIcons/kln-info-active.svg'
import categoriesDisabled from 'assets/klnIcons/kln-categories-disactive.svg'
import categoriesActive from 'assets/klnIcons/kln-categories-active.svg'
import usersDisabled from 'assets/klnIcons/kln-users-disactive.svg'
import usersActive from 'assets/klnIcons/kln-users-active.svg'
import quizDisabled from 'assets/klnIcons/kln-quiz-disactive.svg'
import quizActive from 'assets/klnIcons/kln-quiz-active.svg'

export default {
  name: 'CLeftSideBar',
  props: {
    step: {
      type: Number,
      default: 1,
    },
    isNeedToWait: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      infoDisabled,
      infoActive,
      categoriesDisabled,
      categoriesActive,
      usersDisabled,
      usersActive,
      quizDisabled,
      quizActive,
      altAvatar,
      user: {},
      hide: true,
      modalType: 'logout',
      state: '',
    }
  },
  watch: {
    state() {
      if (this.state === 'logout') {
        !this.isNeedToWait ? this.$app.auth.logout(true) : this.$emit('update:is-logout', true)
      } 
      this.state = ''
    },
  },
  created() {
    $api.auth.info().with('resultedCount').then((response) => {
      this.user = response.data.content.user
      this.$app.auth.user(this.user)
    })
  },
  methods: {
    showModal() {
      this.hide = false
    },
  },
}
</script>

<style scoped lang="scss">
.c-left-side-bar {
  padding: 0 15px;
  background-color: #F4F4F4;

  .c-left-side-bar-container {
    position: relative;
    min-height: 100vh;
    z-index: 9;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0 15px 0;

    .logged-user {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .avatar-place {
        width: 44px;
        height: 44px;
        margin-bottom: 5px;
        img {
          aspect-ratio: auto;
        }
      }
      .name {
        font-size: 0.9em;
        color: var(--secondary);
        text-decoration: underline;
      }
      p {
        font-size: 0.7em;
        color: #6D6F7B;
      }
    }

    .page-icons {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
      min-height: 500px;

      .page-icon {
        position: relative;
        border-radius: 50px;
        width: 54px;
        height: 54px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.active {
          background-color: rgba(255, 188, 13, 0.2);
        }

        &.last-active::before {
          position: absolute;
          content: '';
          border-left: 3px dashed var(--primary);
          height: 65px;
          top: 65px;
        }

        &.last-disabled::before {
          position: absolute;
          content: '';
          border-left: 3px dashed #E2E4EC;
          height: 65px;
          top: 65px;
        }
      }
    }
  }
}

p {
  margin: 0;
  padding: 0;
}
</style>
